module.exports = __webpack_public_path__ + "img/apple-touch-icon.26737759.png";